import React from "react";
import { ArrowRightIcon, CheckIcon } from "lucide-react";
import { included, links } from "../data/content";
import { body, button, eyebrow, h2, shell } from "../utils/styles";
export function Offer() {
  return <section id="unirme" className={`${shell} grid items-center gap-7 pb-[60px] sm:grid-cols-2 sm:gap-10 sm:pb-[95px] lg:gap-20`} data-id="element-117" data-mp="1mmh88hcjhejj">
      <div data-id="element-118" data-mp="1hp7if0l8n0v6">
        <p className={eyebrow} data-id="element-119" data-mp="1hqs4s2xefdhy">Etapa fundadora activa</p>
        <h2 className={h2} data-id="element-120" data-mp="tzmpppza8p8p">Entrá a Radar Digital con precio fundador</h2>
        <p className={`${body} max-w-[350px]`} data-id="element-121" data-mp="p0a2h44i1g5l">
          Esta condición especial está disponible durante la etapa fundadora de la comunidad.
        </p>
        <ul className="mt-[25px]" data-id="element-122" data-mp="13uy5mbmfg2i1">
          {included.map(item => <li key={item} className="flex items-center gap-[13px] border-b border-[#30382a] py-3 text-[13px] text-fg" data-id="element-123" data-mp="yx525qcidmlg">
              <CheckIcon className="h-4 w-4 shrink-0 text-lime" aria-hidden="true" data-id="element-124" data-mp="2fad45juab2f9" />
              {item}
            </li>)}
        </ul>
      </div>

      <div className="rounded-2xl border border-[#687c48] bg-moss-4 px-6 py-7 sm:p-[38px]" data-id="element-125" data-mp="pl0dbw2nnyex">
        <span className="inline-block rounded-[5px] border border-[#536740] bg-[#303f21] px-3 py-2 text-[10px] uppercase tracking-[1px] text-lime" data-id="element-126" data-mp="uiiprwfvsvro">
          Precio fundador
        </span>
        <h3 className="mb-5 mt-[27px] font-display text-[23px] font-medium leading-[1.35] sm:text-2xl" data-id="element-127" data-mp="13ki7ys2mu5w7">
          Membresía mensual Radar Digital
        </h3>
        <p className="m-0 font-display text-[61px] font-medium leading-none tracking-[-3px] text-lime sm:text-[65px]" data-id="element-128" data-mp="6rmpsc19uu9c">
          USD 27
          <small className="ml-[7px] font-sans text-[15px] font-normal tracking-normal text-[#b4bfa7]" data-id="element-129" data-mp="funt64yr679b">/mes</small>
        </p>
        <p className="mb-[25px] mt-[15px] text-xs leading-[1.75] text-muted" data-id="element-130" data-mp="km5voxgfcfwe">
          O <strong className="text-fg" data-id="element-131" data-mp="3k95l8hly53jr">ARS 40.000/mes</strong> para Argentina con Mercado Pago. Futuro precio de
          ingreso: USD 97/mes o ARS 150.000/mes.
        </p>

        <div className="flex flex-col gap-3" data-id="element-132" data-mp="vfqx2230ncs7">
          <a href={links.skool} target="_blank" rel="noopener noreferrer" className={`${button} w-full`} data-id="element-133" data-mp="vepbv4sad9wr">
            Entrar con precio fundador — USD 27/mes
            <ArrowRightIcon className="h-[18px] w-[18px] shrink-0" aria-hidden="true" data-id="element-134" data-mp="155k54t3y99rp" />
          </a>
          <a href={links.mercadopago} target="_blank" rel="noopener noreferrer" className="inline-flex w-full items-center justify-between gap-7 rounded-lg bg-mp px-[21px] py-[17px] text-[13px] font-bold text-white transition-[background-color,transform] duration-200 ease-out hover:-translate-y-0.5 hover:bg-mp-dark" data-id="element-135" data-mp="106pfb77keky3">
            Pagar en Argentina — ARS 40.000/mes
            <ArrowRightIcon className="h-[18px] w-[18px] shrink-0" aria-hidden="true" data-id="element-136" data-mp="hfptgevd9r91" />
          </a>
        </div>
        <p className="mt-[17px] text-center text-[11px] leading-relaxed text-dim" data-id="element-137" data-mp="1wvewswfa5bjj">
          En USD te suscribís desde Skool. En pesos, el enlace abre la suscripción de Mercado Pago.
        </p>

        <p className="mt-6 border-t border-[#465438] pt-5 text-center text-[11px] leading-[1.7] text-[#a9b799]" data-id="element-138" data-mp="20duj1yi63zgr">
          Membresía mensual con renovación automática. Podés cancelar desde la plataforma donde te suscribiste.
        </p>
      </div>
    </section>;
}